// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"landing_wrapper__hs2_m","card":"landing_card__Mb53j","features":"landing_features__21OsZ","featuresTitle":"landing_featuresTitle__1UFd8"};